<ejs-recurrenceeditor
  #recurrenceEditor
  locale="cs"
  data-cy="recurrenceEditor"
  [value]="_value"
  [firstDayOfWeek]="1"
  (change)="onChangeInternal($event)"
></ejs-recurrenceeditor>
